import React from 'react';

const Abouts = () => {
    return (
        <div>
            
        </div>
    );
};

export default Abouts;